module.exports = __webpack_public_path__ + "d6dc0ec3fcf8a4f5d1c52580e8e11706.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/invoice/sms-purchase-invoice.html
// module id = 2001
// module chunks = 0